import React, { useState } from 'react';
import './ChatIcon.css';

const qaTree = [
  {
    question: 'Service you are looking for?',
    options: [
      {
        label: 'Architecture Design',
        followup: [
          { label: 'Residential', answer: 'We offer complete residential architecture design services.' },
          { label: 'Commercial', answer: 'We provide commercial architecture design for offices, shops, and more.' },
          { label: 'Industrial', answer: 'Our team specializes in industrial architecture design.' },
          { label: 'Villa', answer: 'We design luxury and custom villas as per your requirements.' },
          { label: 'Layout', answer: 'We create efficient and regulatory-compliant layout plans.' },
        ],
      },
      {
        label: 'Structural Design',
        followup: [
          { label: 'Residential', answer: 'We provide structural design for residential buildings.' },
          { label: 'Commercial', answer: 'Our engineers deliver safe and efficient commercial structural designs.' },
          { label: 'Industrial', answer: 'We handle complex industrial structural design projects.' },
          { label: 'Villa', answer: 'Get robust structural design for your villa project.' },
        ],
      },
      {
        label: 'Approvals & Due Diligence',
        followup: [
          { label: 'Building permission', answer: 'We assist in obtaining building permissions from authorities.' },
          { label: 'Layout permission', answer: 'Our team helps secure layout permissions for your project.' },
          { label: 'Industrial permission', answer: 'We guide you through the process of getting industrial permissions.' },
        ],
      },
      {
        label: 'Interior Designing',
        followup: [
          { label: '1000-1500 sft', answer: 'We design interiors for spaces between 1000-1500 sft.' },
          { label: '1500-2500 sft', answer: 'Our team creates beautiful interiors for 1500-2500 sft areas.' },
          { label: '2500+ sft', answer: 'We handle large-scale interior design projects above 2500 sft.' },
        ],
      },
      {
        label: 'Exterior Landscape Design',
        followup: [
          { label: 'Residential', answer: 'We design residential landscapes for homes and apartments.' },
          { label: 'Commercial', answer: 'Our team creates commercial landscape designs for offices, malls, etc.' },
          { label: 'Industrial', answer: 'We offer landscape design for industrial premises.' },
          { label: 'Villa', answer: 'Get custom landscape design for your villa.' },
        ],
      },
    ],
  },
];

export default function ChatIcon() {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState({ level: 0, optionIdx: null, subIdx: null });
  const [history, setHistory] = useState([]);
  
  // Check if mobile
  const isMobile = window.innerWidth <= 600;

  const handleOpen = () => {
    setOpen(true);
    setStep({ level: 0, optionIdx: null, subIdx: null });
    setHistory([]);
  };

  const handleSelect = (optionIdx, subIdx = null) => {
    if (step.level === 0) {
      setStep({ level: 1, optionIdx, subIdx: null });
      setHistory([qaTree[0].options[optionIdx].label]);
    } else if (step.level === 1 && subIdx !== null) {
      setStep({ level: 2, optionIdx: step.optionIdx, subIdx });
      setHistory([...history, qaTree[0].options[step.optionIdx].followup[subIdx].label]);
    }
  };

  const handleBack = () => {
    if (step.level === 2) {
      setStep({ level: 1, optionIdx: step.optionIdx, subIdx: null });
      setHistory(history.slice(0, -1));
    } else if (step.level === 1) {
      setStep({ level: 0, optionIdx: null, subIdx: null });
      setHistory([]);
    }
  };

  return (
    <>
      <button 
        className="chat-icon-btn" 
        onClick={handleOpen} 
        aria-label="Open chat"
        style={{
          position: 'fixed',
          bottom: isMobile ? '140px' : '160px',
          right: isMobile ? '8px' : '32px',
          zIndex: 10001,
          background: '#fff',
          border: '2px solid #812121',
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
          cursor: 'pointer'
        }}
      >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="chat-icon-svg">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>
      {open && (
        <div className="chat-overlay">
          <div className="chat-box">
            <button className="chat-close-btn" onClick={() => setOpen(false)} aria-label="Close chat">&times;</button>
            <div className="chat-messages qa-chat">
              <div className="chat-message system">Do you have any queries? Select a service below:</div>
              {step.level === 0 && (
                <div className="qa-options">
                  {qaTree[0].options.map((opt, idx) => (
                    <button key={opt.label} className="qa-btn" onClick={() => handleSelect(idx)}>{opt.label}</button>
                  ))}
                </div>
              )}
              {step.level === 1 && (
                <div className="qa-options">
                  <div className="chat-message user">{qaTree[0].options[step.optionIdx].label}</div>
                  {qaTree[0].options[step.optionIdx].followup.map((sub, subIdx) => (
                    <button key={sub.label} className="qa-btn" onClick={() => handleSelect(step.optionIdx, subIdx)}>{sub.label}</button>
                  ))}
                  <button className="qa-back-btn" onClick={handleBack}>Back</button>
                </div>
              )}
              {step.level === 2 && (
                <div className="qa-options">
                  <div className="chat-message user">{qaTree[0].options[step.optionIdx].label} - {qaTree[0].options[step.optionIdx].followup[step.subIdx].label}</div>
                  <div className="chat-message system">{qaTree[0].options[step.optionIdx].followup[step.subIdx].answer}</div>
                  <div className="chat-message system qa-final">For more queries, contact us through WhatsApp below.</div>
                  <button className="qa-back-btn" onClick={handleBack}>Back</button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
} 